import ReactDOM from "react-dom/client";
import { Application } from "./Application";
import "./polyfills";

import "./styles.scss";
import "./tailwind.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <Application />
  // </React.StrictMode>
);
